import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/Account',
    name: 'Account',
    component: () => import('../views/Account.vue'),
  },
  {
    path: '/',
    name: 'MemberSearch',
    props: true,
    component: () => import('../views/Members/Search.vue'),
  },
  {
    path: '/Aurora',
    redirect: {path: '/'}
  },
  {
    path: '/AuroraData',
    redirect: {path: '/'}
  },
  {
    path: '/Lumora',
    redirect: {path: '/'}
  },
  {
    path: '/Fidecs',
    redirect: {path: '/'}
  },
  {
    path: '/RunReport',
    name: 'RunReport',
    component: () => import('../views/Reports/RunReport.vue'),
  },
  {
    path: '/InvestmentReport',
    name: 'InvestmentReport',
    component: () => import('../views/Investments/InvestmentReport.vue'),
  },
 
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
